import * as React from 'react';
import { MainMenuComponent } from 'components/mainmenu/MainMenuComponent';
import { Navigation } from 'utils/Navigation';
import { SceneFactory } from 'scenes/SceneFactory';
import { Rpc } from 'rpc/rpc';
import { LinearProgress, createMuiTheme, MuiThemeProvider } from '@material-ui/core';

export class MainStage extends React.Component<{}, State> {

    public constructor(props: {}) {
        super(props);

        this.handleFetchingStateChanged = this.handleFetchingStateChanged.bind(this);

        this.state = { isFetching: Rpc.isFetching };
    }

    public componentDidMount() {
        Rpc.onFetchingStateChanged.addListener(this.handleFetchingStateChanged);
    }

    public componentWillUnmount() {
        Rpc.onFetchingStateChanged.removeListener(this.handleFetchingStateChanged);
    }

    private handleFetchingStateChanged(isFetching: boolean) {
        this.setState({ isFetching: Rpc.isFetching });
    }

    public render() {
        var sceneFactory = SceneFactory.getFactory(Navigation.currentState.path);
        var scene = null;
        if (sceneFactory != null) {
            scene = sceneFactory.create(Navigation.currentState);
        }
        return (
            <MuiThemeProvider theme={theme}>
                <MainMenuComponent currentUrl={Navigation.currentState.path} />
                <div style={{ width: '100%', minWidth: '1280px', minHeight: '100%', paddingLeft: '300px', backgroundColor: '#f8f8f8' }}>
                    {scene == null && (<div>No scene is registered for this path</div>)}
                    {scene != null && scene}
                </div>

                {this.state.isFetching && (
                    <div style={{ position: 'fixed', left: '0px', top: '0px', right: '0px', bottom: '0px', zIndex: 99999, pointerEvents: 'none' }}>
                        <LinearProgress style={{ width: '100%' }} />
                    </div>
                )}

                <div style={{
                    position: 'fixed',
                    width: '40px',
                    height: '150px',
                    zIndex: 10000,
                    backgroundColor: "#6DAF24",
                    right: '0px',
                    top: '' + (window.innerHeight / 2 - 75) + 'px',
                    boxShadow: '1px 1px 20px rgba(0,0,0, 0.5)',
                    cursor: 'pointer'
                }}
                onClick={()=> {
                    Navigation.pushState(null, "/contactus.rsc");
                }}
                >
                    <div style={{ fontSize: '16px', fontWeight: 600, color: '#fff', transformOrigin: '0% 0%', transform: 'rotate(-90deg) translate(-114px, 10px)', letterSpacing: '1px' }}>
                        Feedback
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }

}

interface State {

    isFetching: boolean;

}

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    zIndex: {
        modal: 20000,
    }
})